import styled from "styled-components"
import media from "styled-media-query"

import { colors } from "~/styles"
import background from "~/assets/images/bg-banner.jpg"
import icon from "~/assets/images/icon-boia.svg"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 70rem;
  width: 100%;

  padding: 6rem 4rem;

  color: ${colors.lighter};

  background-image: url(${background});
  background-size: cover;

  ${media.greaterThan("medium")`
    padding: 14rem 6rem 0;
  `}
`

export const Content = styled.div`
  font-size: 1.4rem;

  h1 {
    margin-bottom: 10px;

    display: flex;
    align-items: center;
    font-size: 3rem;
    color: ${colors.secondary};

    &:before {
      display: inline-block;
      width: 30px;
      height: 30px;
      margin-right: 10px;

      content: "";
      background-image: url(${icon});
      background-size: cover;
    }
  }

  p {
    margin-bottom: 3rem;
    text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
  }

  ${media.greaterThan("medium")`
    width: 45rem;
    h1 {
      font-size: 5rem;

      &:before {
        width: 50px;
        height: 50px;
      }
    }
    
    button {
      font-size: 1.6rem;
    }
  `}
`
